module.exports = __webpack_public_path__ + "assets/plus_grey-c4f249.svg";